import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';
import { TimeDimension, SortOrder } from '@/lib/services/watchlist.service';
import { SkillInfo } from '../services/mcp.service';
type DataState = {
  skillList: SkillInfo[];
};

const dataInitState: DataState = {
  skillList: [],
};

const skillSlice = createSlice({
  name: 'skill',
  initialState: dataInitState,
  reducers: {
    setSkillList: (state, action: { payload: SkillInfo[] }) => {
      state.skillList = action.payload;
    },
  },
});

export const reduxSkillList = (state: RootState) =>
  state.skill.skillList;

export const {
  setSkillList,
} = skillSlice.actions;
export default skillSlice.reducer;
